import type { SxProps, Theme } from '@mui/material';

export const panelSx: SxProps<Theme> = {
  maxWidth: (theme) => theme.spacing(80),
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
};

export const inlineIconSx: SxProps<Theme> = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 0.75,
  '& svg': { width: 16, height: 16, flexShrink: 0 },
};

export const recordTypeSx: SxProps<Theme> = {
  px: 0.75,
  py: 0.25,
  borderRadius: 1,
  fontSize: (theme) => theme.typography.pxToRem(11),
  fontWeight: 600,
  letterSpacing: '0.04em',
  color: 'custom.OV.sys.onSurfaceVariant',
  backgroundColor: 'custom.OV.sys.surfaceContainerHigh',
  alignSelf: 'flex-start',
};

export const recordValueSx: SxProps<Theme> = {
  fontFamily: 'monospace',
  fontSize: (theme) => theme.typography.pxToRem(13),
  wordBreak: 'break-all',
};

export const mutedSx: SxProps<Theme> = { color: 'custom.OV.sys.onSurfaceVariant' };

export const recordLabelSx: SxProps<Theme> = { ...mutedSx, width: 40 };

export const foldButtonSx: SxProps<Theme> = {
  width: '100%',
  justifyContent: 'flex-start',
  textTransform: 'none',
  color: 'custom.OV.sys.onSurface',
  fontWeight: 600,
  px: 0,
};
